module.exports = __webpack_public_path__ + "img/shipo-icon-upload.c1873dcb.svg";